import React, { useState, useEffect } from 'react'
import { Card, Table, Form } from 'react-bootstrap'
import api from 'api/api'
import { toast } from 'react-toastify'
import { formatNumberForDisplay } from 'utils/numberUtils'
import { getServerDate, startOfMonth, endOfMonth } from 'utils/date'
import { LoadingSpinner } from 'components/LoadingSpinner'
import { DateRangeSelector } from 'components/DateRangeSelector'

const ProductosMasVendidos = () => {
	const [loading, setLoading] = useState(false)
	const [fechaInicio, setFechaInicio] = useState(getServerDate(startOfMonth()))
	const [fechaFin, setFechaFin] = useState(getServerDate(endOfMonth()))
	const [productos, setProductos] = useState([])
	const [categorias, setCategorias] = useState([])
	const [categoriaId, setCategoriaId] = useState('')
	const [limit, setLimit] = useState(10)

	useEffect(() => {
		const cargarCategorias = async () => {
			try {
				const response = await api.get('a/reportes/categorias-lista')
				if (!response.error && response.datos) {
					setCategorias(response.datos)
				}
			} catch (error) {
				console.error('Error cargando categorias:', error)
			}
		}
		cargarCategorias()
	}, [])

	const cargarDatos = async (inicio, fin, catId, lim) => {
		try {
			setLoading(true)
			let url = `a/reportes/productos-mas-vendidos?fechaInicio=${inicio}&fechaFin=${fin}&limit=${lim}`
			
			if (catId) {
				url += `&categoriaId=${catId}`
			}

			const response = await api.get(url)

			if (response.error) {
				toast.error(response.msg || 'Error al cargar datos')
				return
			}

			setProductos(response.datos || [])

		} catch (error) {
			console.error('Error:', error)
			toast.error('Error al cargar el reporte')
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		cargarDatos(fechaInicio, fechaFin, categoriaId, limit)
	}, [])

	const handleRangeChange = (inicio, fin) => {
		setFechaInicio(inicio)
		setFechaFin(fin)
	}

	const handleConsultar = (inicio, fin) => {
		cargarDatos(inicio, fin, categoriaId, limit)
	}

	const formatMonto = (value) => {
		return formatNumberForDisplay(value.toString()) + ' Gs.'
	}

	return (
		<div className="productos-mas-vendidos">
			<DateRangeSelector
				fechaInicio={new Date(fechaInicio.replace(/-/g, '/'))}
				fechaFin={new Date(fechaFin.replace(/-/g, '/'))}
				onRangeChange={handleRangeChange}
				onConsultar={handleConsultar}
			/>

			<div className="d-flex gap-3 mb-4 align-items-center flex-wrap">
				<div className="d-flex align-items-center gap-2">
					<Form.Label className="mb-0 text-muted">Categoria:</Form.Label>
					<Form.Select
						value={categoriaId}
						onChange={(e) => {
							const newCatId = e.target.value
							setCategoriaId(newCatId)
							cargarDatos(fechaInicio, fechaFin, newCatId, limit)
						}}
						style={{ width: '200px' }}
						size="sm"
					>
						<option value="">Todas las categorias</option>
						{categorias.map(cat => (
							<option key={cat.id} value={cat.id}>{cat.nombre}</option>
						))}
					</Form.Select>
				</div>

				<div className="d-flex align-items-center gap-2">
					<Form.Label className="mb-0 text-muted">Mostrar:</Form.Label>
					<Form.Select
						value={limit}
						onChange={(e) => {
							const newLimit = parseInt(e.target.value)
							setLimit(newLimit)
							cargarDatos(fechaInicio, fechaFin, categoriaId, newLimit)
						}}
						style={{ width: '120px' }}
						size="sm"
					>
						<option value="10">Top 10</option>
						<option value="20">Top 20</option>
						<option value="50">Top 50</option>
					</Form.Select>
				</div>
			</div>

			{loading ? (
				<div className="d-flex justify-content-center py-5">
					<LoadingSpinner />
				</div>
			) : (
				<Card>
					<Card.Body className="p-0">
						{productos.length > 0 ? (
							<Table hover responsive className="mb-0">
								<thead className="table-light">
									<tr>
										<th style={{ width: '60px' }}>#</th>
										<th>Codigo</th>
										<th>Producto</th>
										<th>Categoria</th>
										<th className="text-end">Cantidad</th>
										<th className="text-end">Monto Total</th>
									</tr>
								</thead>
								<tbody>
									{productos.map((prod, index) => (
										<tr key={prod.id}>
											<td>
												<span className={`ranking-badge ${index < 3 ? 'top-3' : ''}`}>
													{index + 1}
												</span>
											</td>
											<td className="text-muted font-monospace">{prod.codigo || '-'}</td>
											<td className="fw-medium">{prod.nombre}</td>
											<td>
												<span className="badge bg-light text-primary">
													{prod.categoriaNombre}
												</span>
											</td>
											<td className="text-end fw-bold">{prod.cantidadVendida}</td>
											<td className="text-end fw-bold text-success">
												{formatMonto(prod.montoTotal)}
											</td>
										</tr>
									))}
								</tbody>
							</Table>
						) : (
							<div className="text-center text-muted py-5">
								<i className="fa fa-box-open fa-3x mb-3"></i>
								<p>No hay productos vendidos en el periodo seleccionado</p>
							</div>
						)}
					</Card.Body>
				</Card>
			)}
		</div>
	)
}

export default ProductosMasVendidos